/**
 * Block ids with a RUNNING library-adaptation task (AC-P1-069) — lets
 * FlowBlockNode render a node-level «AI adapting…» state without owning any
 * subscription (BlockCanvasEditor drives the set from task listeners;
 * components stay presentation-only per the imperative-first rule).
 */
import { createContext, useContext } from 'react';

const AdaptingBlocksContext = createContext<ReadonlySet<string>>(new Set());

export const AdaptingBlocksProvider = AdaptingBlocksContext.Provider;

export function useAdaptingBlocks(): ReadonlySet<string> {
  return useContext(AdaptingBlocksContext);
}
